import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const SpecificationsProduct = () => {
    return (
        <div className="specifications-product">
            <div className="container container-xl-small">
                <div className="title xmb-6 d-block d-lg-none">
                    <div className="title-box just-text title-box-blue">
                        <div className="title-bg">
                            <h2 className="text">
                                مشخصات فنی
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="accordion">
                    <div className="accordion-item">
                        <div className="accordion-header accordion-button" id="panels-stay-open-heading-one"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-one" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-one">
                            <span className="title-toggle">
                                <IconName name="aspect_ratio" className="icon"/>
                                صفحه‌ی نمایش
                            </span>
                            <p className="info-product">۶.۱ اینچ • ۸۲۸ × ۱۷۹۲ پیکسل</p>
                            <IconName name='expand_more' className="icon icon-more position-absolute"/>
                        </div>
                        <div id="panels-stay-open-collapse-one" className="accordion-collapse collapse show"
                             aria-labelledby="panels-stay-open-heading-one">
                            <div className="accordion-body">
                                <div className="key-info-list">
                                    <ul className="list-unstyled">
                                        <li>
                                            <div className="key-info">صفحه نمایش رنگی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">صفحه نمایش لمسی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">فناوری</div>
                                            <div className="value-info">IPS</div>
                                        </li>
                                        <li>
                                            <div className="key-info">بازه‌ی اندازه صفحه نمایش</div>
                                            <div className="value-info">6.0 اینچ و بزرگتر</div>
                                        </li>
                                        <li>
                                            <div className="key-info">اندازه</div>
                                            <div className="value-info">6.06.53 اینچ</div>
                                        </li>
                                        <li>
                                            <div className="key-info">رزولوشن</div>
                                            <div className="value-info">1080 × 2340 پیکسل</div>

                                        </li>
                                        <li>
                                            <div className="key-info">تراکم پیکسلی</div>
                                            <div className="value-info">395 پیکسل بر هر اینچ</div>

                                        </li>
                                        <li>
                                            <div className="key-info">نسبت صفحه‌نمایش به بدنه</div>
                                            <div className="value-info">84.9 درصد</div>
                                        </li>
                                        <li>
                                            <div className="key-info">نسبت تصویر</div>
                                            <div className="value-info"> 19.5:9</div>
                                        </li>
                                        <li>
                                            <div className="key-info">محافظت</div>
                                            <div className="value-info">Corning Gorilla Glass 5</div>
                                        </li>
                                        <li>
                                            <div className="key-info">تعداد رنگ</div>
                                            <div className="value-info">16 میلیون رنگ</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> سایر قابلیت‌ها</div>
                                            <div className="value-info">پشتیبانی از استاندارد HDR</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> حداکثر میزان روشنایی</div>
                                            <div className="value-info">500 نیت</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <div className="accordion-header accordion-button collapsed" id="panels-stay-open-heading-two"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-two" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-two">
                            <span className="title-toggle">
                                <IconName name="straighten" className="icon"/>
                                ابعاد و وزن
                            </span>
                            <p className="info-product">۸.۳ × ۷۵.۷ × ۱۵۰.۹ میلی‌متر• ۱۹۴ گرم</p>
                            <IconName name='expand_more' className="icon icon-more position-absolute"/>
                        </div>
                        <div id="panels-stay-open-collapse-two" className="accordion-collapse collapse"
                             aria-labelledby="panels-stay-open-heading-two">
                            <div className="accordion-body">
                                <div className="key-info-list">
                                    <ul className="list-unstyled">
                                        <li>
                                            <div className="key-info">صفحه نمایش رنگی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">صفحه نمایش لمسی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">فناوری</div>
                                            <div className="value-info">IPS</div>
                                        </li>
                                        <li>
                                            <div className="key-info">بازه‌ی اندازه صفحه نمایش</div>
                                            <div className="value-info">6.0 اینچ و بزرگتر</div>
                                        </li>
                                        <li>
                                            <div className="key-info">اندازه</div>
                                            <div className="value-info">6.06.53 اینچ</div>
                                        </li>
                                        <li>
                                            <div className="key-info">رزولوشن</div>
                                            <div className="value-info">1080 × 2340 پیکسل</div>

                                        </li>
                                        <li>
                                            <div className="key-info">تراکم پیکسلی</div>
                                            <div className="value-info">395 پیکسل بر هر اینچ</div>

                                        </li>
                                        <li>
                                            <div className="key-info">نسبت صفحه‌نمایش به بدنه</div>
                                            <div className="value-info">84.9 درصد</div>
                                        </li>
                                        <li>
                                            <div className="key-info">نسبت تصویر</div>
                                            <div className="value-info"> 19.5:9</div>
                                        </li>
                                        <li>
                                            <div className="key-info">محافظت</div>
                                            <div className="value-info">Corning Gorilla Glass 5</div>
                                        </li>
                                        <li>
                                            <div className="key-info">تعداد رنگ</div>
                                            <div className="value-info">16 میلیون رنگ</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> سایر قابلیت‌ها</div>
                                            <div className="value-info">پشتیبانی از استاندارد HDR</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> حداکثر میزان روشنایی</div>
                                            <div className="value-info">500 نیت</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="accordion-item">
                        <div className="accordion-header accordion-button collapsed" id="panels-stay-open-heading-three"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-three" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-three">
                            <span className="title-toggle">
                                <IconName name="battery_charging_full" className="icon"/>
                                مشخصات باتری
                            </span>
                            <p className="info-product">باتری از نوع لیتیوم-یون با ظرفیت ۳۱۱۰ میلی‌آمپرساعت</p>
                            <IconName name='expand_more' className="icon icon-more position-absolute"/>
                        </div>
                        <div id="panels-stay-open-collapse-three" className="accordion-collapse collapse"
                             aria-labelledby="panels-stay-open-heading-three">
                            <div className="accordion-body">
                                <div className="key-info-list">
                                    <ul className="list-unstyled">
                                        <li>
                                            <div className="key-info">صفحه نمایش رنگی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">صفحه نمایش لمسی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">فناوری</div>
                                            <div className="value-info">IPS</div>
                                        </li>
                                        <li>
                                            <div className="key-info">بازه‌ی اندازه صفحه نمایش</div>
                                            <div className="value-info">6.0 اینچ و بزرگتر</div>
                                        </li>
                                        <li>
                                            <div className="key-info">اندازه</div>
                                            <div className="value-info">6.06.53 اینچ</div>
                                        </li>
                                        <li>
                                            <div className="key-info">رزولوشن</div>
                                            <div className="value-info">1080 × 2340 پیکسل</div>

                                        </li>
                                        <li>
                                            <div className="key-info">تراکم پیکسلی</div>
                                            <div className="value-info">395 پیکسل بر هر اینچ</div>

                                        </li>
                                        <li>
                                            <div className="key-info">نسبت صفحه‌نمایش به بدنه</div>
                                            <div className="value-info">84.9 درصد</div>
                                        </li>
                                        <li>
                                            <div className="key-info">نسبت تصویر</div>
                                            <div className="value-info"> 19.5:9</div>
                                        </li>
                                        <li>
                                            <div className="key-info">محافظت</div>
                                            <div className="value-info">Corning Gorilla Glass 5</div>
                                        </li>
                                        <li>
                                            <div className="key-info">تعداد رنگ</div>
                                            <div className="value-info">16 میلیون رنگ</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> سایر قابلیت‌ها</div>
                                            <div className="value-info">پشتیبانی از استاندارد HDR</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> حداکثر میزان روشنایی</div>
                                            <div className="value-info">500 نیت</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="accordion-item">
                        <div className="accordion-header accordion-button collapsed" id="panels-stay-open-heading-four"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-four" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-four">
                            <span className="title-toggle">
                                <IconName name="memory" className="icon"/>
حافظه و ذخیره سازی                            </span>
                            <p className="info-product">حافظه داخلی ۱۲۸ گیگ • رم ۴ گیگ</p>
                            <IconName name='expand_more' className="icon icon-more position-absolute"/>
                        </div>
                        <div id="panels-stay-open-collapse-four" className="accordion-collapse collapse"
                             aria-labelledby="panels-stay-open-heading-four">
                            <div className="accordion-body">
                                <div className="key-info-list">
                                    <ul className="list-unstyled">
                                        <li>
                                            <div className="key-info">صفحه نمایش رنگی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">صفحه نمایش لمسی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">فناوری</div>
                                            <div className="value-info">IPS</div>
                                        </li>
                                        <li>
                                            <div className="key-info">بازه‌ی اندازه صفحه نمایش</div>
                                            <div className="value-info">6.0 اینچ و بزرگتر</div>
                                        </li>
                                        <li>
                                            <div className="key-info">اندازه</div>
                                            <div className="value-info">6.06.53 اینچ</div>
                                        </li>
                                        <li>
                                            <div className="key-info">رزولوشن</div>
                                            <div className="value-info">1080 × 2340 پیکسل</div>

                                        </li>
                                        <li>
                                            <div className="key-info">تراکم پیکسلی</div>
                                            <div className="value-info">395 پیکسل بر هر اینچ</div>

                                        </li>
                                        <li>
                                            <div className="key-info">نسبت صفحه‌نمایش به بدنه</div>
                                            <div className="value-info">84.9 درصد</div>
                                        </li>
                                        <li>
                                            <div className="key-info">نسبت تصویر</div>
                                            <div className="value-info"> 19.5:9</div>
                                        </li>
                                        <li>
                                            <div className="key-info">محافظت</div>
                                            <div className="value-info">Corning Gorilla Glass 5</div>
                                        </li>
                                        <li>
                                            <div className="key-info">تعداد رنگ</div>
                                            <div className="value-info">16 میلیون رنگ</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> سایر قابلیت‌ها</div>
                                            <div className="value-info">پشتیبانی از استاندارد HDR</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> حداکثر میزان روشنایی</div>
                                            <div className="value-info">500 نیت</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="accordion-item">
                        <div className="accordion-header accordion-button collapsed" id="panels-stay-open-heading-five"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-five" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-five">
                            <span className="title-toggle">
                                <IconName name="cpu" className="icon"/>
                                پردازنده
                            </span>
                            <p className="info-product">Apple A13 Bionic (7 nm+) Chipset</p>
                            <IconName name='expand_more' className="icon icon-more position-absolute"/>
                        </div>
                        <div id="panels-stay-open-collapse-five" className="accordion-collapse collapse"
                             aria-labelledby="panels-stay-open-heading-five">
                            <div className="accordion-body">
                                <div className="key-info-list">
                                    <ul className="list-unstyled">
                                        <li>
                                            <div className="key-info">صفحه نمایش رنگی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">صفحه نمایش لمسی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">فناوری</div>
                                            <div className="value-info">IPS</div>
                                        </li>
                                        <li>
                                            <div className="key-info">بازه‌ی اندازه صفحه نمایش</div>
                                            <div className="value-info">6.0 اینچ و بزرگتر</div>
                                        </li>
                                        <li>
                                            <div className="key-info">اندازه</div>
                                            <div className="value-info">6.06.53 اینچ</div>
                                        </li>
                                        <li>
                                            <div className="key-info">رزولوشن</div>
                                            <div className="value-info">1080 × 2340 پیکسل</div>

                                        </li>
                                        <li>
                                            <div className="key-info">تراکم پیکسلی</div>
                                            <div className="value-info">395 پیکسل بر هر اینچ</div>

                                        </li>
                                        <li>
                                            <div className="key-info">نسبت صفحه‌نمایش به بدنه</div>
                                            <div className="value-info">84.9 درصد</div>
                                        </li>
                                        <li>
                                            <div className="key-info">نسبت تصویر</div>
                                            <div className="value-info"> 19.5:9</div>
                                        </li>
                                        <li>
                                            <div className="key-info">محافظت</div>
                                            <div className="value-info">Corning Gorilla Glass 5</div>
                                        </li>
                                        <li>
                                            <div className="key-info">تعداد رنگ</div>
                                            <div className="value-info">16 میلیون رنگ</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> سایر قابلیت‌ها</div>
                                            <div className="value-info">پشتیبانی از استاندارد HDR</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> حداکثر میزان روشنایی</div>
                                            <div className="value-info">500 نیت</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="accordion-item">
                        <div className="accordion-header accordion-button collapsed" id="panels-stay-open-heading-six"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-six" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-six">
                            <span className="title-toggle">
                                <IconName name="camera_alt" className="icon"/>
                                دوربین عکاسی
                            </span>
                            <p className="info-product">۱۲.۰ مگاپیکسل</p>
                            <IconName name='expand_more' className="icon icon-more position-absolute"/>
                        </div>
                        <div id="panels-stay-open-collapse-six" className="accordion-collapse collapse"
                             aria-labelledby="panels-stay-open-heading-six">
                            <div className="accordion-body">
                                <div className="key-info-list">
                                    <ul className="list-unstyled">
                                        <li>
                                            <div className="key-info">صفحه نمایش رنگی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">صفحه نمایش لمسی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">فناوری</div>
                                            <div className="value-info">IPS</div>
                                        </li>
                                        <li>
                                            <div className="key-info">بازه‌ی اندازه صفحه نمایش</div>
                                            <div className="value-info">6.0 اینچ و بزرگتر</div>
                                        </li>
                                        <li>
                                            <div className="key-info">اندازه</div>
                                            <div className="value-info">6.06.53 اینچ</div>
                                        </li>
                                        <li>
                                            <div className="key-info">رزولوشن</div>
                                            <div className="value-info">1080 × 2340 پیکسل</div>

                                        </li>
                                        <li>
                                            <div className="key-info">تراکم پیکسلی</div>
                                            <div className="value-info">395 پیکسل بر هر اینچ</div>

                                        </li>
                                        <li>
                                            <div className="key-info">نسبت صفحه‌نمایش به بدنه</div>
                                            <div className="value-info">84.9 درصد</div>
                                        </li>
                                        <li>
                                            <div className="key-info">نسبت تصویر</div>
                                            <div className="value-info"> 19.5:9</div>
                                        </li>
                                        <li>
                                            <div className="key-info">محافظت</div>
                                            <div className="value-info">Corning Gorilla Glass 5</div>
                                        </li>
                                        <li>
                                            <div className="key-info">تعداد رنگ</div>
                                            <div className="value-info">16 میلیون رنگ</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> سایر قابلیت‌ها</div>
                                            <div className="value-info">پشتیبانی از استاندارد HDR</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> حداکثر میزان روشنایی</div>
                                            <div className="value-info">500 نیت</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="accordion-item">
                        <div className="accordion-header accordion-button collapsed" id="panels-stay-open-heading-seven"
                             data-bs-toggle="collapse"
                             data-bs-target="#panels-stay-open-collapse-seven" aria-expanded="false"
                             aria-controls="panels-stay-open-collapse-seven">
                            <span className="title-toggle">
                                <IconName name="videocam" className="icon"/>
                                فیلمبرداری
                            </span>
                            <p className="info-product">رزولوشن 2160 × 3840 و سرعت 24/30/60 فریم بر ثانیه
                                (2160p@24/30/60FPS)</p>
                            <IconName name='expand_more' className="icon icon-more position-absolute"/>
                        </div>
                        <div id="panels-stay-open-collapse-seven" className="accordion-collapse collapse"
                             aria-labelledby="panels-stay-open-heading-seven">
                            <div className="accordion-body">
                                <div className="key-info-list">
                                    <ul className="list-unstyled">
                                        <li>
                                            <div className="key-info">صفحه نمایش رنگی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">صفحه نمایش لمسی</div>
                                            <div className="value-info">بله</div>
                                        </li>
                                        <li>
                                            <div className="key-info">فناوری</div>
                                            <div className="value-info">IPS</div>
                                        </li>
                                        <li>
                                            <div className="key-info">بازه‌ی اندازه صفحه نمایش</div>
                                            <div className="value-info">6.0 اینچ و بزرگتر</div>
                                        </li>
                                        <li>
                                            <div className="key-info">اندازه</div>
                                            <div className="value-info">6.06.53 اینچ</div>
                                        </li>
                                        <li>
                                            <div className="key-info">رزولوشن</div>
                                            <div className="value-info">1080 × 2340 پیکسل</div>

                                        </li>
                                        <li>
                                            <div className="key-info">تراکم پیکسلی</div>
                                            <div className="value-info">395 پیکسل بر هر اینچ</div>

                                        </li>
                                        <li>
                                            <div className="key-info">نسبت صفحه‌نمایش به بدنه</div>
                                            <div className="value-info">84.9 درصد</div>
                                        </li>
                                        <li>
                                            <div className="key-info">نسبت تصویر</div>
                                            <div className="value-info"> 19.5:9</div>
                                        </li>
                                        <li>
                                            <div className="key-info">محافظت</div>
                                            <div className="value-info">Corning Gorilla Glass 5</div>
                                        </li>
                                        <li>
                                            <div className="key-info">تعداد رنگ</div>
                                            <div className="value-info">16 میلیون رنگ</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> سایر قابلیت‌ها</div>
                                            <div className="value-info">پشتیبانی از استاندارد HDR</div>
                                        </li>
                                        <li>
                                            <div className="key-info"> حداکثر میزان روشنایی</div>
                                            <div className="value-info">500 نیت</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SpecificationsProduct;
